import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('unstructured'),
  titleToNamespace: true,
  avatarPath: avatars.unstructured,
  logoPath: logos.unstructured
});
